import { Component, Input, OnInit } from '@angular/core';
import { BaseCellStepper } from '../model';
import { NbDialogService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { RowCell, GridCell, Section } from '@urbannex/storethemes';
import { SectionBuilderStoreService } from '../../section-builder-store.service';

@Component({
  selector: 'kve-testimonial-cell-stepper',
  templateUrl: './testimonial-cell-stepper.component.html',
  styleUrls: ['./testimonial-cell-stepper.component.scss']
})
export class TestimonialCellStepperComponent  extends BaseCellStepper implements OnInit{
  
  @Input() cell:GridCell|RowCell;
  @Input() section:Section;

  constructor(
    //ref: NbDialogRef<SectionCellStepperComponent>,
    dialogService:NbDialogService,
    ofbizFormsService:OfbizFormsService,
    sectionBuilderStoreService:SectionBuilderStoreService,
    configurationService:ConfigurationService){
    super(dialogService,ofbizFormsService,sectionBuilderStoreService,configurationService)
  }

  ngOnInit(): void {
    console.log(this.cell);
    this.sectionBuilderStoreService.updateSelectedCell(this.cell);
    this.contentEnum = this.cell.contentEnum;
    console.log(this.contentEnum)
    this.stepperTitle = this.getStepperTitle(this.contentEnum)
    this.contentElements = this.cell.contentElements;
    this.baseUrl = this.configurationService.getBaseUrl();
  }
  
}
